__turbopack_context__.v({
  "close": "HTMLDialogModal-module-scss-module__3jWm5G__close",
  "dialogButtons": "HTMLDialogModal-module-scss-module__3jWm5G__dialogButtons",
  "htmlDialog": "HTMLDialogModal-module-scss-module__3jWm5G__htmlDialog",
});
